import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'

import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  actionUpdateCart,
  actionRemoveCart,
  actionRemoveAllCart,
  actionGetVoucher,
} from '../../store/actions/cart'
import { actionSaveTransaction } from '../../store/actions/transaction'
import { actionSettingReferral } from '../../store/actions/util'

import { formatPrice, formatDiscount, formatPrecentage, getDiscount, getCleanUrlReferral, appendReferralIfPresent } from '../../helpers'

const CartQuantityControl = ({ item, itemPrice, onUpdateQuantity }) => {
  const [val, setVal] = useState(item.quantity)

  useEffect(() => {
    setVal(item.quantity)
  }, [item.quantity])

  const handleChange = (e) => {
    const inputValue = e.target.value
    setVal(inputValue)

    if (inputValue !== '') {
      const parsed = parseInt(inputValue, 10)
      if (!isNaN(parsed) && parsed >= 1) {
        onUpdateQuantity(item.product, itemPrice, parsed)
      }
    }
  }

  const handleBlur = () => {
    const parsed = parseInt(val, 10)
    if (isNaN(parsed) || parsed < 1) {
      setVal(1)
      onUpdateQuantity(item.product, itemPrice, 1)
    } else {
      setVal(parsed)
      onUpdateQuantity(item.product, itemPrice, parsed)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur()
    }
  }

  const handleDecrease = () => {
    if (item.quantity > 1) {
      onUpdateQuantity(item.product, itemPrice, (parseInt(item.quantity, 10) || 1) - 1)
    }
  }

  const handleIncrease = () => {
    onUpdateQuantity(item.product, itemPrice, (parseInt(item.quantity, 10) || 1) + 1)
  }

  return (
    <div className="nice-number">
      <button
        type="button"
        onClick={handleDecrease}
      >-</button>
      <input
        type="number"
        min="1"
        value={val}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      />
      <button
        type="button"
        onClick={handleIncrease}
      >+</button>
    </div>
  )
}

const Cart = ({
  history,
  authenticate,
  contact,
  cart,
  voucher,
  transaction,
  util,
  dispatchUpdateCart,
  dispatchRemoveCart,
  dispatchRemoveAllCart,
  dispatchSaveTransaction,
  dispatchGetVoucher,
  dispatchSettingReferral
}) => {
  const [total, setTotal] = useState(0)
  const [discount, setDiscount] = useState(0)
  const [message, setMessage] = useState('')
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('')
  const [onState, setOnState] = useState(false)

  const activeReferralCode = getCleanUrlReferral(history.location, history)

  useEffect(() => {
    if (activeReferralCode) {
      dispatchSettingReferral()
    }
  }, [activeReferralCode, dispatchSettingReferral])

  const referralDiscount = activeReferralCode ? util?.settingReferral?.payload?.price_discount : null

  const getItemPrice = (item) => {
    const normalPrice = item.normal_price || item.product?.price || 0
    const discountObj = item.discount || item.product?.discount
    const precentage = formatPrecentage(authenticate.account, discountObj, referralDiscount)
    return getDiscount(normalPrice, precentage)
  }

  useEffect(() => {
    const newTotal = cart.payload.reduce((current, item) => {
      const itemPrice = getItemPrice(item)
      return current + (itemPrice * item.quantity)
    }, 0)
    setTotal(newTotal)
  }, [cart.payload, authenticate.account, util.settingReferral, activeReferralCode])

  useEffect(() => {
    if (voucher.payload) {
      setDiscount(parseFloat(voucher.payload?.value || 0))
      return
    }

    setDiscount(0)
  }, [voucher.payload])

  useEffect(() => {
    if (voucher.payload && total < parseFloat(voucher.payload?.min_purchase)) {
      dispatchGetVoucher(code, total)
    }
  }, [total, voucher.payload])

  const handlePageHome = () => {
    history.push(appendReferralIfPresent('/', history.location))
  }

  const handleChangeCode = (event) => {
    setCode(event.target.value)
  }

  const handleSearchVoucher = () => {
    if (!voucher.loading) {
      dispatchGetVoucher(code, total)
    }
  }

  const handleUpdateQuantity = (product, price, quantity) => {
    if (quantity > 0) {
      dispatchUpdateCart(product, price, quantity)
    }
  }

  const handleRemoveCart = (productId) => {
    dispatchRemoveCart(productId)
  }

  useEffect(() => {
    if (transaction.payload && onState) {
      setOnState(false)
      dispatchRemoveAllCart()
      const baseUrl = window.location.origin
      const detailUrl = `${baseUrl}/pembelian/${transaction.payload}`
      const text = `Kode ${transaction.payload}%0ALink: ${detailUrl}%0A%0A${message}`
      window.open(`${process.env.REACT_APP_WHATSAPP_URL}${phone}&text=${text}`, '_blank')

      if (history) {
        history.push(`/pembelian/${transaction.payload}`)
      } else {
        window.location.href = `/pembelian/${transaction.payload}`
      }
    }
  }, [transaction.payload, dispatchRemoveAllCart, onState, message, phone, history])

  const handleCheckout = () => {
    if (!transaction.loading && !voucher.loading) {
      const data = {
        total: 0,
        user_id: (authenticate.account) ? authenticate.account.id : null,
        orders: [],
        voucher_id: (voucher.payload) ? voucher.payload?.id : null,
      }

      if (activeReferralCode) {
        data.referral = activeReferralCode
      }

      let text = ''
      for (const item of cart.payload) {
        const itemPrice = getItemPrice(item)
        data.total += (Number(itemPrice) * Number(item.quantity))
        data.orders.push({
          quantity: Number(item.quantity),
          price: Number(itemPrice),
          product_id: item.product.id
        })
        text += `- ${item.product.name} @${formatPrice(itemPrice, 'Rp.')} x ${item.quantity}%0A`
      }

      if (authenticate.account) {
        text += `%0ATotal Belanja ${formatPrice(total, 'Rp.')}`
        if (discount > 0) {
          text += `%0APotongan Harga ${formatPrice(discount, '- Rp.')}`
        }
      }
      text += `%0ATotal Bayar ${formatPrice((total - discount), 'Rp.')}`

      setMessage(text)
      setPhone(contact.payload.phone)
      setOnState(true)
      dispatchSaveTransaction(data)
      setDiscount(0)
      setCode('')
    }
  }

  return (
    <>
      <div className="breadcrumb-halaman">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a
                onClick={handlePageHome}
                className="clickable"
              >Beranda</a>
            </li>
            <li className="breadcrumb-item active">Keranjang belanja</li>
          </ol>
        </nav>
      </div>
      <div className="totalbayar-mobile">
        <div className="voucher-mobile">
          <label htmlFor="voucher">Kode Voucher</label>
          <div className="form-voucher">
            <input
              type="text"
              name="voucher"
              id="voucher"
              value={code}
              onChange={handleChangeCode}
            />

            <div
              className="btn-voucher"
              onClick={handleSearchVoucher}
            >
              Gunakan
            </div>
          </div>
        </div>
        <div className="detail">
          <div className="isi-total">
            <p className="totalharga">Total Bayar</p>
            <p className="total">{formatPrice((total - discount), 'Rp.')}</p>
            {
              (discount > 0) && (
                <p className="totalpotongan">{formatPrice(total, 'Rp.')}</p>
              )
            }
          </div>
          {
            (cart.payload.length > 0)
              ? <div onClick={handleCheckout} className="btn-bayar">
                <a className="btn-bayar">
                  {
                    (transaction.loading || voucher.loading)
                      ? 'Menunggu..'
                      : `Beli produk (${cart.payload.length})`
                  }
                </a>
              </div>
              : null
          }
        </div>
      </div>
      <div className="container">
        <div className="cover-keranjang-all">
          <div className="cover-isi">
            <div className="cover-card-produk">
              <h2 className="judul">Keranjang belanja</h2>
              {
                (cart.payload.length > 0)
                  ? <>
                    {
                      cart.payload.map((item, index) => {
                        const itemPrice = getItemPrice(item)
                        return (
                          <div key={index} className="card-produk">
                            <img
                              src={process.env.REACT_APP_IMAGE_URL + item.product.image}
                              alt={item.product.name}
                            />
                            <div className="isi-konten">
                              <p className="judul">{item.product.name}</p>
                              <p className="harga">{formatPrice(itemPrice, 'Rp.')}</p>
                            </div>
                            <div className="btn-card-prod">
                              <CartQuantityControl
                                item={item}
                                itemPrice={itemPrice}
                                onUpdateQuantity={handleUpdateQuantity}
                              />
                              <a className="pointer" onClick={() => handleRemoveCart(item.product.id)}>Hapus</a>
                            </div>
                          </div>
                        )
                      })
                    }
                  </>
                  : <div className="btn-bayar">
                    <a onClick={handlePageHome} className="btn-bayar">Belanja Sekarang!</a>
                  </div>
              }
            </div>
            <div className="totalbayar">
              <h2 className="ringkasan"> Ringkasan belanja</h2>
              {
                authenticate.account && (
                  <div className="voucher">
                    <label htmlFor="voucher">Kode Voucher</label>
                    <div className="form-voucher">
                      <input
                        type="text"
                        name="voucher"
                        id="voucher"
                        value={code}
                        onChange={handleChangeCode}
                      />

                      <div
                        className="btn-voucher"
                        onClick={handleSearchVoucher}
                      >
                        Gunakan
                      </div>
                    </div>
                  </div>
                )
              }

              <div className="isi-total">
                {
                  authenticate.account && (
                    <>
                      <p className="totalharga">Total Belanja</p>
                      <p className="total">{formatPrice(total, 'Rp.')}</p>
                      <p className="totalharga">Potongan Harga</p>
                      <p className="totalpotongan">{formatPrice(discount, '- Rp.')}</p>
                    </>
                  )
                }
                <p className="totalharga">Total Bayar</p>
                <p className="total">{formatPrice((total - discount), 'Rp.')}</p>
              </div>

              {
                (cart.payload.length > 0)
                  ? <div onClick={handleCheckout} className="btn-bayar">
                    <a className="btn-bayar">
                      {
                        (transaction.loading || voucher.loading)
                          ? 'Menunggu..'
                          : `Beli produk (${cart.payload.length})`
                      }
                    </a>
                  </div>
                  : null
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    authenticate: {
      account: state.auth.authenticate.account
    },
    voucher: {
      loading: state.cart.getVoucher.loading,
      payload: state.cart.getVoucher.payload
    },
    contact: {
      payload: state.util.contact.payload
    },
    cart: {
      payload: state.cart.getCart.payload
    },
    transaction: {
      loading: state.transaction.saveTransaction.loading,
      payload: state.transaction.saveTransaction.payload
    },
    util: {
      settingReferral: state.util.settingReferral
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUpdateCart: (product, price, quantity) => dispatch(actionUpdateCart(product, price, quantity)),
    dispatchRemoveCart: (productId) => dispatch(actionRemoveCart(productId)),
    dispatchRemoveAllCart: () => dispatch(actionRemoveAllCart()),
    dispatchSaveTransaction: (data) => dispatch(actionSaveTransaction(data)),
    dispatchGetVoucher: (name, total) => dispatch(actionGetVoucher(name, total)),
    dispatchSettingReferral: () => dispatch(actionSettingReferral())
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Cart)